// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"DeviceInfo_style_b-icon-warning__JgprI","wrapper":"DeviceInfo_style_wrapper__589L4","rotate":"DeviceInfo_style_rotate__DqKiD"};